import { render } from "./MainView.vue?vue&type=template&id=e5e6a052"
import script from "./main-view-component.ts?vue&type=script&lang=js&external"
export * from "./main-view-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__